'use client'
import { useState } from 'react'
import cl from 'clsx'
import Title from '@/ui/title'
import Accordion from '@/ui/accordion'
import IdeaImages from './idea-images'
import styles from './styles.module.css'

export default function Idea({ dict }) {
    const [activeIndex, setActiveIndex] = useState(1)

    return (
        <section id="idea" className={cl(styles.idea, 'container')} data-name="idea">
            <Title
                titleSm={dict.idea.title_sm}
                title={dict.idea.title}
            />
            <div className={styles.layout}>
                <div className={styles.left}>
                    <Accordion
                        dict={dict}
                        activeIndex={activeIndex}
                        onActiveChange={setActiveIndex}
                    />
                </div>
                <div className={styles.right}>
                    <IdeaImages activeIndex={activeIndex} />
                </div>
            </div>
        </section>
    )
}
